import React from 'react'
import { Portal } from '../portal'

const PopupCore = ({
  onClose = () => {},
  customWidth,
  relative,
  children,
  customPadding = 'pt-20 lg:pt-0'
}) => {
  const handleClose = (e) => {
    if(e){
      e.preventDefault()
      e.stopPropagation()
    }

    onClose()
  }

  return (
    <Portal>
      <div
        className="fixed left-0 top-0 w-full h-screen overflow-y-auto"
        style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)', animation: 'darkFadeIn 0.1s ease-in-out'}}
        onClick={handleClose}
      >
        <div className={`container mx-auto ${customPadding} my-10 pointer-events-none`}>
          <div className={`mx-auto px-4 py-5 lg:px-8 lg:py-8 bg-white rounded pointer-events-none ${customWidth ? customWidth : 'w-full lg:w-6/12'} ${relative ? 'relative' : ''}`} style={{animation: 'scaleIn 0.2s cubic-bezier(.4,1.13,.85,.85)'}}>
            <div className="lg:w-auto mx-auto pointer-events-auto" onClick={(e) => e.stopPropagation()}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </Portal>
  )
}

export { PopupCore }
